import { observable } from 'mobx';
import type { IPagingSelectionManager, IPagingSelectionManagerData } from '@src/slide/application/service/paging-selection/core/paging-selection-manager.interface';

class PagingSelectionManager implements IPagingSelectionManager {
    @observable
    public visible: boolean;
    @observable
    public data: IPagingSelectionManagerData;

    public waitingToClose: Promise<void> = Promise.resolve();

    public setVisible(visible: boolean): Promise<void> {
        return visible ? this.show() : this.close();
    }

    public getVisible(): boolean {
        return this.visible;
    }

    public updateData(data: IPagingSelectionManagerData): IPagingSelectionManager {
        return this.chain(() => this.data = Object.assign({}, this.data, data));
    }

    private chain(fn: Function) {
        fn();
        return this;
    }

    /**
     * 选页框展示逻辑
     * container 节点务必已经 mounted
     */
    private async show() {
        // 避免 close 马上又 show 的快速操作
        await this.waitingToClose;
        this.visible = true;
    }

    /**
     * 关闭弹窗，等待动画结束后销毁，组件内部调用
     * @param closeFn
     * @returns Promise<void>
     */
    private close() {
        this.waitingToClose = new Promise((resolve) => {
            setTimeout(() => {
                this.visible = false;
                resolve();
            }, 300);
        });
        return this.waitingToClose;
    }
}

export default PagingSelectionManager;
